import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Reactable from 'reactable';

class BarbersReport extends Component {
  renderLargeSingleRow(singleReport) {
    const Tr = Reactable.Tr;
    const Td = Reactable.Td;
    return (
      <Tr key={`large_${singleReport.barberName}`}>
        <Td
          column="Barber"
          data={singleReport.barberName}
          className="u-text-left u-pl--"
        >
          {singleReport.barberName}
        </Td>
        <Td column="PaidViaSquireCount" data={singleReport.paidViaSquireCount}>{singleReport.paidViaSquireCount}</Td>
        <Td column="PaidInShopViaPosCount" data={singleReport.paidInShopViaPosCount}>{singleReport.paidInShopViaPosCount}</Td>
        <Td column="PaidInShopOtherCount" data={singleReport.paidInShopOtherCount}>{singleReport.paidInShopOtherCount}</Td>
        <Td column="Total" data={singleReport.appointmentCount}>{singleReport.appointmentCount}</Td>
        <Td column="No-Shows" data={singleReport.noShowAppointmentCount}>{singleReport.noShowAppointmentCount}</Td>
        <Td column="Cancellations" data={singleReport.canceledAppointmentCount}>{singleReport.canceledAppointmentCount}</Td>
      </Tr>
    );
  }

  renderSmallSingleRow(singleReport) {
    const Tr = Reactable.Tr;
    const Td = Reactable.Td;
    return (
      <Tr key={`small_${singleReport.barberName}`}>
        <Td column="Barber" data={singleReport.barberName}>{singleReport.barberName}</Td>
        <Td column="Total" data={singleReport.appointmentCount}>{singleReport.appointmentCount}</Td>
      </Tr>
    );
  }

  render() {
    const { barberReports, summary } = this.props;

    const sortableSmall = [
      'Barber',
      'Total',
    ];
    const sortableLarge = sortableSmall.concat([
      'Cancellations',
      'No-Shows',
      'PaidInShopViaPosCount',
      'PaidInShopOtherCount',
      'PaidViaSquireCount',
    ]);

    const Table = Reactable.Table;
    const Thead = Reactable.Thead;
    const Th = Reactable.Th;
    const Tfoot = Reactable.Tfoot;

    let report = null;
    let smallReport = null;

    if (barberReports.length) {
      report = barberReports.map(barberReport => this.renderLargeSingleRow(barberReport));
      smallReport = barberReports.map(barberReport => this.renderSmallSingleRow(barberReport));
    }

    return (
      <div className="u-mt+">
        <Table
          className="c-table-new c-table--small c-table--border c-no-hover table-visible-for-extra-extralarge-and-down"
          sortable={sortableSmall}
        >
          <Thead>
            <Th column="Barber">
              <span className="barber-header">Barber</span>
            </Th>
            <Th column="Total" title="Total barber income paid in shop and via Squire">
              <span className="total-header">Total</span>
            </Th>
          </Thead>
          {smallReport}
        </Table>
        <Table
          className="c-table-new c-table--small c-table--border c-no-hover table-visible-for-extra-extralarge-and-up"
          id="table"
          sortable={sortableLarge}
        >
          <Thead>
            <Th column="Barber">
              <span className="barber-header">Barber</span>
            </Th>
            <Th column="PaidViaSquireCount" title="Number of services paid via Squire">
              <span className="paid-via-squire-header">Squire Services</span>
            </Th>
            <Th column="PaidInShopViaPosCount" title="Number of services paid in the shop via POS">
              <span className="paid-in-shop-pos-header">In-Shop POS Services</span>
            </Th>
            <Th column="PaidInShopOtherCount" title="Number of services paid in the shop">
              <span className="paid-in-shop-other-header">In-Shop Cash Services</span>
            </Th>
            <Th column="Total" title="Total services count">
              <span className="total-header">Total</span>
            </Th>
            <Th column="No-Shows" title="Number of no-show services">
              <span className="no-shows-header">No-Shows</span>
            </Th>
            <Th column="Cancellations" title="Number of cancelled services">
              <span className="cancellations-header">Cancelled</span>
            </Th>
          </Thead>
          {report}
          <Tfoot>
            <tr className="u-type--bold">
              <td className="u-text-left u-pl--">
                Total
              </td>
              <td>
                {summary.paidViaSquireCount}
              </td>
              <td>
                {summary.paidInShopViaPosCount}
              </td>
              <td>
                {summary.paidInShopOtherCount}
              </td>
              <td>
                {summary.totalCount}
              </td>
              <td>
                {summary.noShowAppointmentCount}
              </td>
              <td>
                {summary.canceledAppointmentCount}
              </td>
            </tr>
          </Tfoot>
        </Table>
      </div>
    );
  }
}

BarbersReport.propTypes = {
  barberReports: PropTypes.array.isRequired,
  summary: PropTypes.object.isRequired,
};

export default BarbersReport;
